<template>
<div class="action-button">
	<div v-show="false">
		<slot></slot>
	</div>
	<template v-if="buttonList.length<=2">
		<span v-for="(item,index) in buttonList" :key="index" :class="{ml6:index>0}">
			<VNode :vnode="item" />
		</span>
	</template>
	<template v-if="buttonList.length>2">
		<VNode :vnode="buttonList[0]" />
		<el-dropdown trigger="click" style="margin-left:6px">
			<span class="el-dropdown-link">
				<a>更多<i class="el-icon-arrow-down el-icon--right"></i></a>
			</span>
			<el-dropdown-menu>
				<el-dropdown-item v-for="(item,index) in moreList" :key="index" >
					<VNode :vnode="item" />
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
	</template>
	
</div>
</template>
<script>
export default {
	name:"TableActionButton",
	components:{
		VNode:{
			functional: true,
    		render: (h, {props}) => props.vnode
		}
	},
	data(){
		return {
			buttonList:[],

		}
	},
	computed:{
		//更多按钮列表
		moreList () {
			if(this.buttonList.length<=2)return[];
			return this.buttonList.slice(1,this.buttonList.length);
		}
	},
	created(){
		this.$nextTick(()=>{
			//筛选选a标签按钮
			this.buttonList = this.$slots.default.filter(item=>item.tag=="a");
		})
	},
	beforeUpdate(){
		this.buttonList = this.$slots.default.filter(item=>item.tag=="a");
	},
	methods:{
	}
}
</script>
<style lang="less">
	// .moreBtns-content{
	// 	z-index: 9 !important;
	// 	a{
	// 		display:block;
	// 		padding:5px 10px;
	// 		font-size: 14px;
	// 	}
	// }
	.ml6{
		margin-left: 6px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/TableActionButton.vue